export default __webpack_public_path__ + "static/media/LO03.631c1984.mp3";